var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebookCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 31,
    viewBox: "0 0 30 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.693359,
    width: 30,
    height: 30,
    rx: 15,
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_14300_49289)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.1782 16.1309L18.5948 13.4162H15.99V11.6546C15.99 10.9119 16.3539 10.188 17.5205 10.188H18.7047V7.87676C18.7047 7.87676 17.6301 7.69336 16.6026 7.69336C14.4575 7.69336 13.0554 8.99355 13.0554 11.3473V13.4162H10.6709V16.1309H13.0554V22.6934H15.99V16.1309H18.1782Z",
    fill: "#143860"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_14300_49289"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 9.375,
    height: 15,
    fill: "white",
    transform: "translate(10 7.69336)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebookCircle);
export default __webpack_public_path__ + "static/media/facebook-circle.bcf5be70c38a1d30725dd883adb2028a.svg";
export { ForwardRef as ReactComponent };